<template>
  <div class="login-page">
    <div class="login-atmosphere atmosphere-one"></div>
    <div class="login-atmosphere atmosphere-two"></div>

    <section class="login-story">
      <div class="login-brand">
        <div class="brand-mark brand-mark-large">
          <span></span><span></span><span></span>
        </div>
        <div>
          <strong>Message Gateway</strong>
          <small>MESSAGE GATEWAY</small>
        </div>
      </div>
      <p class="login-kicker">AI VOICE · PHASE 1</p>
      <h1>Every message,<br>clear and traceable.</h1>
      <p class="login-copy">
        A secure operations console for SMS, voice, push notifications,
        delivery records and provider callbacks.
      </p>
      <div class="login-metrics">
        <div><strong>01</strong><span>Unified message model</span></div>
        <div><strong>03</strong><span>Integrated channels</span></div>
        <div><strong>24/7</strong><span>Traceable status</span></div>
      </div>
    </section>

    <section class="login-card">
      <div class="login-card-head">
        <span class="secure-badge"><i class="el-icon-lock"></i> SECURE CONSOLE</span>
        <h2>Welcome back</h2>
        <p>Sign in with your Message Gateway account.</p>
      </div>

      <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="submit">
        <el-form-item prop="username">
          <label>Username</label>
          <el-input
            v-model.trim="form.username"
            prefix-icon="el-icon-user"
            autocomplete="username"
            placeholder="Enter your username"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item prop="password">
          <label>Password</label>
          <el-input
            v-model="form.password"
            prefix-icon="el-icon-key"
            type="password"
            autocomplete="current-password"
            show-password
            placeholder="Enter your password"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-alert
          v-if="errorMessage"
          :title="errorMessage"
          type="error"
          :closable="false"
          show-icon
        />
        <el-button class="login-button" type="primary" :loading="loading" @click="submit">
          Sign in
          <i v-if="!loading" class="el-icon-right"></i>
        </el-button>
      </el-form>

    </section>
  </div>
</template>

<script>
import { login } from '../api/admin'

export default {
  name: 'LoginView',
  data () {
    return {
      loading: false,
      errorMessage: '',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: 'Enter your username', trigger: 'blur' }],
        password: [{ required: true, message: 'Enter your password', trigger: 'blur' }]
      }
    }
  },
  created () {
    if (this.$store.state.token) {
      const roles = (this.$store.state.user && this.$store.state.user.roles) || []
      const defaultRoute = roles.includes('SMS_RECORD_QUERY') && !roles.some(role => ['VIEWER', 'OPERATOR', 'OPS', 'ADMIN'].includes(role))
        ? '/sms-record-query'
        : '/dashboard'
      this.$router.replace(defaultRoute)
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate(async valid => {
        if (!valid || this.loading) return
        this.loading = true
        this.errorMessage = ''
        try {
          const session = await login(this.form)
          this.$store.commit('setSession', session)
          const roles = (session.user && session.user.roles) || []
          const defaultRoute = roles.includes('SMS_RECORD_QUERY') && !roles.some(role => ['VIEWER', 'OPERATOR', 'OPS', 'ADMIN'].includes(role))
            ? '/sms-record-query'
            : '/dashboard'
          this.$router.replace(this.$route.query.redirect || defaultRoute)
        } catch (error) {
          this.errorMessage = (error.response && error.response.data && error.response.data.message) ||
            'Unable to sign in. Check your account details and try again.'
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

